import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "user-blocked" }
const _hoisted_2 = { class: "user-blocked__title" }

import { type PropType } from 'vue';

import { ModalContent, ModalFooter, modalVariant, type ModalVariant } from '@exchange/libs/modals/src';


export default /*#__PURE__*/_defineComponent({
  __name: 'UserBlocked',
  props: {
  variant: { type: String as PropType<ModalVariant>, default: modalVariant.light },
},
  emits: ["close"],
  setup(__props, { emit: __emit }) {



const emit = __emit;

return (_ctx: any,_cache: any) => {
  const _component_x_link_external = _resolveComponent("x-link-external")!
  const _component_i18n_t = _resolveComponent("i18n-t")!
  const _component_x_button = _resolveComponent("x-button")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_unref(ModalContent), { variant: __props.variant }, {
      default: _withCtx(() => [
        _createElementVNode("h4", _hoisted_2, _toDisplayString(_ctx.$t('modules.transactions.userBlocked.title')), 1),
        _createVNode(_component_i18n_t, {
          class: "user-blocked__message",
          keypath: "modules.transactions.userBlocked.text",
          tag: "p",
          scope: "global"
        }, {
          linkText: _withCtx(() => [
            _createVNode(_component_x_link_external, {
              href: _ctx.$t('modules.transactions.userBlocked.linkHref')
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('modules.transactions.userBlocked.linkText')), 1)
              ]),
              _: 1
            }, 8, ["href"])
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["variant"]),
    _createVNode(_unref(ModalFooter), null, {
      default: _withCtx(() => [
        _createVNode(_component_x_button, {
          class: "user-not-verified__verify",
          variant: "primary",
          text: _ctx.$t('fundamentals.ok'),
          onClick: _cache[0] || (_cache[0] = ($event: any) => (emit('close')))
        }, null, 8, ["text"])
      ]),
      _: 1
    })
  ]))
}
}

})